import React, { useMemo } from 'react';
import LclKanbanColumn from './LclKanbanColumn';
import LclOperationCard from '../LclOperationCard';

/**
 * Columna "Rechazadas" — agrupa solicitudes LCL en estado `Rechazada`.
 *
 * Archivo independiente para poder ajustar esta columna sin tocar
 * las otras tres ni nada del módulo aéreo.
 */
const LclRechazadasColumn = ({
  items = [],
  onAction,
  loading = false,
  headerExtra,
  actionsMode = 'full',
}) => {
  // `renderItem` se memoriza para no recrearlo en cada render del padre
  const renderItem = useMemo(
    () => (r) => (
      <LclOperationCard
        r={r}
        variant="rechazadas"
        onAction={onAction}
        actionsMode={actionsMode}
      />
    ),
    [onAction, actionsMode],
  );

  return (
    <LclKanbanColumn
      id="rechazadas"
      title="Rechazadas"
      accent="border-t-rose-500"
      badge="bg-rose-100 text-rose-800 border-rose-200"
      items={items}
      renderItem={renderItem}
      loading={loading}
      emptyText="Sin solicitudes rechazadas"
      headerExtra={headerExtra}
    />
  );
};

export default LclRechazadasColumn;
